import { useQuery, useQueryClient } from '@tanstack/react-query';
import AppLayout from '../../components/AppLayout';
import { useParams, useSearchParams } from 'react-router';
import AdminApi from '../../apis/admin_api';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import AdminReportTable from '../../components/AdminReportTable';
import { toast } from 'react-toastify';
import { useUserDetails } from '../../helpers/UserContext';
import { setToken } from '../../apis/LocalStorageApi';
import { handleError } from '../../apis';
import AdminDaysSince from '../../components/AdminDaysSince';

export default function AdminPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const since = searchParams.get('since') || '';
  const { id } = useParams();
  const queryClient = useQueryClient();
  const [, , setUserFromToken] = useUserDetails();
  const { data, isPending, error, isError } = useQuery({
    queryKey: ['adminDataForUser', id, since],
    queryFn: async () =>
      await AdminApi.getAdminDataForUser(
        id!,
        since ? parseInt(since) : undefined,
      ),
    enabled: !!id,
  });
  const impersonate = async (email: string) => {
    try {
      const response = await AdminApi.impersonateUser(email);
      if (response.token) {
        queryClient.clear();
        setToken(response.token as string);
        setUserFromToken(response.token as string);
        toast.success('Login successful!');
      }
    } catch (error) {
      console.error('Error impersonating user:', error);
      const message = await handleError(error);
      toast.error(message);
    }
  };

  return (
    <AppLayout>
      <div className='text-center'>
        <h3 className='text-center text-2xl dark:text-gray-300 mb-1'>Admin</h3>
        <p className='font-bold'>{data?.email}</p>
        <p className='mb-2'>initial 04/19/2026</p>
      </div>

      <AdminDaysSince since={since} setSince={setSearchParams} />
      <ShowPending isPending={isPending} />
      <ShowError isError={isError} error={error} />
      {data && (
        <AdminReportTable
          data={[data]}
          impersonate={impersonate}
          showPagination={false}
        />
      )}
    </AppLayout>
  );
}
